import React, { useState } from 'react';
import SEO from './SEO';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    error: null
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitted: false, submitting: true, error: null });

    try {
      const response = await fetch('https://formspree.io/f/xgvkqqye', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          _subject: `New Contact Form Submission - ${formData.service}`,
          _replyto: formData.email,
        }),
      });

      if (response.ok) {
        setStatus({ submitted: true, submitting: false, error: null });
        setFormData({ name: '', email: '', phone: '', service: '', message: '' });
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (error) {
      setStatus({ submitted: false, submitting: false, error: 'Failed to submit form. Please try again.' });
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const contactSchema = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    'name': 'Contact Copper Canyon Pressure Wash',
    'description': 'Get in touch with Copper Canyon Pressure Wash for professional pressure washing services in Phoenix, Scottsdale, Mesa, Tempe, Gilbert, and Paradise Valley.',
    'mainEntity': {
      '@type': 'Organization',
      'name': 'Copper Canyon Pressure Wash',
      'telephone': '+16027300728',
      'email': 'coppercanyonpressurewash@gmail.com',
      'openingHoursSpecification': [
        {
          '@type': 'OpeningHoursSpecification',
          'dayOfWeek': ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          'opens': '00:00',
          'closes': '23:59'
        }
      ]
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <SEO 
        title="Contact Copper Canyon Pressure Wash | Schedule Your Service"
        description="Get in touch with our team for professional pressure washing services in Phoenix and surrounding areas. Fast response, free estimates, and flexible scheduling."
        schema={contactSchema}
        keywords="schedule pressure washing, book cleaning service, Phoenix pressure washing contact, emergency cleaning service, same day service, weekend appointments, business hours, customer support, service area, service request"
      />

      <div className="max-w-3xl mx-auto">
      <h1 className="text-4xl font-bold text-[#4a3f35] mb-6">Contact Us</h1>
        
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div>
            <h2 className="text-2xl font-semibold text-[#b87c4c] mb-4">Get in Touch</h2>
            <div className="space-y-4">
        <div>
                <h3 className="font-semibold text-[#4a3f35] mb-1">Phone</h3>
                <a href="tel:6027300728" className="text-gray-700 hover:text-[#b87c4c]">
                  (602) 730-0728
                </a>
                <p className="text-sm text-gray-500 mt-1">
                  Available 8:00 AM - 6:00 PM (Mon-Sat)
                </p>
        </div>
        <div>
                <h3 className="font-semibold text-[#4a3f35] mb-1">Email</h3>
                <a href="mailto:coppercanyonpressurewash@gmail.com" className="text-gray-700 hover:text-[#b87c4c]">
                  coppercanyonpressurewash@gmail.com
                </a>
        </div>
        <div>
                <h3 className="font-semibold text-[#4a3f35] mb-1">Service Hours</h3>
                <p className="text-gray-700">24 Hours (Monday-Saturday)</p>
                <p className="text-gray-700">Closed Sunday</p>
              </div>
            </div>
        </div>

          <div>
            <h2 className="text-2xl font-semibold text-[#b87c4c] mb-4">Send Us a Message</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
        <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                  Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#b87c4c] focus:border-transparent"
                />
          </div>

        <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                  Email *
                </label>
            <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#b87c4c] focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                  Phone *
                </label>
            <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#b87c4c] focus:border-transparent"
                />
              </div>

              <div>
                <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-1">
                  Service Interested In *
                </label>
                <select
                  id="service"
                  name="service"
                  required
                  value={formData.service}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#b87c4c] focus:border-transparent"
                >
                  <option value="">Select a service</option>
                  <option value="Driveway Cleaning">Driveway Cleaning</option>
                  <option value="Solar Panel Cleaning">Solar Panel Cleaning</option>
                  <option value="Pool Deck Cleaning">Pool Deck Cleaning</option>
                  <option value="Patio Cleaning">Patio Cleaning</option>
                  <option value="Concrete Cleaning">Concrete Cleaning</option>
                  <option value="Graffiti Removal">Graffiti Removal</option>
                  <option value="Window Cleaning">Window Cleaning</option>
                  <option value="Gutter Cleaning">Gutter Cleaning</option>
                  <option value="Sidewalk Cleaning">Sidewalk Cleaning</option>
                  <option value="Deck Cleaning">Deck Cleaning</option>
                  <option value="Fence Cleaning">Fence Cleaning</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                  Message *
            </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#b87c4c] focus:border-transparent"
                ></textarea>
              </div>

              <button
                type="submit"
                disabled={status.submitting}
                className="w-full px-6 py-3 bg-[#8B4513] text-white font-medium rounded-lg shadow-md hover:bg-[#6B3410] transition-colors duration-200 disabled:opacity-50"
              >
                {status.submitting ? 'Sending...' : 'Send Message'}
              </button>

              {status.submitted && (
                <p className="text-green-600 text-center">
                  Thank you for your message! We'll get back to you soon.
                </p>
              )}

              {status.error && (
                <p className="text-red-600 text-center">
                  {status.error}
                </p>
              )}
            </form>
          </div>
        </div>
        </div>
    </div>
  );
}

export default Contact; 